// --- FINAL, CORRECTED FILE: apps/website/src/stores/ui/index.ts ---

import { create } from 'zustand';
import { createGoalEditorSlice, type GoalEditorSlice } from './goalEditor.slice';
import { createProjectEditorSlice, type ProjectEditorSlice } from './projectEditor.slice';
import { createSprintEditorSlice, type SprintEditorSlice } from './sprintEditor.slice';
import { createTaskInspectorSlice, type TaskInspectorSlice } from './taskInspector.slice';
import { createHistoryModalSlice, type HistoryModalSlice } from './historyModal.slice';

/**
 * The complete, combined state and actions for the global UI store.
 * This single type is composed of all the individual slice interfaces.
 *
 * --- FIX: Added the new actions from TaskInspectorSlice to the combined type. ---
 */
type UiState = GoalEditorSlice &
  ProjectEditorSlice &
  SprintEditorSlice &
  TaskInspectorSlice & // This type already includes all the new actions
  HistoryModalSlice;

/**
 * The single global Zustand store for the admin UI.
 *
 * It combines all the separate state "slices" into one unified store. This provides
 * a single hook (`useUiStore`) for components to access any part of the global UI state,
 * while keeping the source code organized and maintainable.
 */
export const useUiStore = create<UiState>()((...a) => ({
  ...createGoalEditorSlice(...a),
  ...createProjectEditorSlice(...a),
  ...createSprintEditorSlice(...a),
  ...createTaskInspectorSlice(...a),
  ...createHistoryModalSlice(...a),
}));

export type UiStoreState = UiState;